<script>
    import { onMount } from 'svelte';
    import { functions, break_session, user } from '../stores.js';

    import HighlightClips from './HighlightClips.svelte';
    import ClosedCaption from './ClosedCaption.svelte';

    let videoPlayer;
    export let videoSrc;
    let time;
    let showCCWindow = false;
    let showCCMesages = false;

    let conversation;
    let messages;

    let status = "";
    // let loggedIn = false;

    const initializeHLS = () => {
        // const videoSrc = "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8"
        // videoPlayer.src = "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8"
        // videoPlayer.play();
        if (Hls.isSupported()) {
            var hls = new Hls();
            hls.loadSource(videoSrc);
            hls.attachMedia(videoPlayer);
            hls.on(Hls.Events.MANIFEST_PARSED, function() {
            console.log('hls.on')
            videoPlayer.play();
            });
        } else if (videoPlayer.canPlayType('application/vnd.apple.mpegurl')) {
            videoPlayer.src = videoSrc;
            // videoPlayer.src = "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8";
            videoPlayer.addEventListener('loadedmetadata', function() {
                console.log('loadedmetadata');
                videoPlayer.play();
            });
        }
    }

    const loadIntialMessages = async() => {
        const messagesPage = await conversation.getEvents({ event_type: "custom:cctext", page_size: 10, order: "desc" });
        // messages = Array.from(messagesPage.items);
        // questions = Array.from(questionsPage.items);
        // messages = Object.entries(messagesPage.items);
        // questions = Object.entries(questionsPage.items);
        // console.log('initial messages: ', messagesPage);
        // console.log('initial questions: ', questionsPage);
        // messages = messagesPage.items;
        messages = new Map([...messagesPage.items.entries()].sort());
        console.log('initial messages: ', messages);
    }


    async function loadCC(){
        console.log("loadCC");
        status = "loading..."
        try {
            const getJWT = $functions.httpsCallable('getJWT');
            const response = await getJWT({username: "cc-user" , conversationId: $break_session.conversationId});
            const jwt = response.data.jwt;
            console.log('jwt: ',jwt);
            const client = new NexmoClient({debug:false});
            const app = await client.createSession(jwt);
            conversation = await app.getConversation($break_session.conversationId);
            console.log('joinRoom conversation: ',conversation);  
            //get early messages and questions if any;
            loadIntialMessages();
            //set up event listeners
            conversation.on('cctext', (sender, event)=>{
                console.log('got cctext event!: ',sender, event);
                //add question to questions
                // questions = [...questions, ]
                // messages.set(event.id,{...event, ...sender});
                messages.set(event.id,event);
                messages = messages;
                console.log('messages on custom event cctext: ',messages);
            });
            // loggedIn = true;
        }
        catch (error){
            console.error('error in setup: ', error);
            status = `Error in setup: ${error}`;
        }


    }
</script>

<svelte:head>
    <script src="https://cdn.jsdelivr.net/npm/hls.js@latest" on:load={initializeHLS}></script>
</svelte:head>

<div>
    <div id="container">
        {#if showCCWindow}
            {#if !conversation}
                <div>
                    <br/><br/>Note: This is pretty experimental! It's using the <a href="https://developer.mozilla.org/en-US/docs/Web/API/Web_Speech_API" target="_blank">Web Speech API</a>. There may also be some delay.
                    <br/><button on:click={loadCC}>got it!</button>  
                    <br/>{status}                      
                </div>
            {:else}
                <ClosedCaption messages = {messages} conversation = {conversation} />
            {/if}
        {/if}
        <div id="video-container">
            <video controls bind:this={videoPlayer} bind:currentTime={time} src=""></video>
            <br/>May need to click play to start the stream. <button on:click={() => showCCWindow = !showCCWindow}>{showCCWindow ? "close" : "open"} closed caption</button>    
        </div>
    </div>
    {#if $user}
        <HighlightClips time = {time} />
    {:else}
        Please sign in to create highlight clips.
    {/if}
</div>

<style>
    #container {
        display: flex;
    }
    #video-container {
        width: 100%
    }
    video {
        width: 100%;
    }
</style>